import React, { useEffect, useRef, useState } from "react";
import { CiSearch } from "react-icons/ci";
import Select,  { components } from "react-select";
import { MdArrowOutward } from "react-icons/md";
import { FaLocationDot } from "react-icons/fa6";
import { LiaDownloadSolid } from "react-icons/lia";
import { Container, Row, Col, Button } from "react-bootstrap";
import ApiService from "../../services/ApiService";
import { toast } from "react-toastify";
import { MultiSelect } from "react-multi-select-component";
import { Link, useLocation, useNavigate } from "react-router-dom";
import HireTheTalent from "./HireTheTalent";
import { ChevronLeft, ChevronRight } from "lucide-react";
import Paginator from "../../components/Paginator";
import Lottie from "lottie-react";
import NoResultAnimation from "../../assets/animations/No Result Green theme.json"
import  LocationDot  from "../../assets/images/location.png";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import logo from "../../assets/images/logo.png";
import blank from "../../assets/images/blank.png";
import Image from "../../components/Image";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { useUser } from "../../context/UserContext";


const Talents = () => {
  const { profileData } = useUser();
  const [talents, setTalents] = useState([]);
  const [pagination, setPagination] = useState({
    current_page: 1,
    total_pages: 1,
  });
  const hasFetchedProfile = useRef(false);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [subCategoryOptions, setSubCategoryOptions] = useState([]);
  const [formData, setFormData] = useState({ category: null, subCategory: [] });
  const [selectedTalentIds, setSelectedTalentIds] = useState([]);
  const [selectedTalentData, setSelectedTalentData] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  console.log('selected data', selectedTalentData)
  const getQueryParam = (key) => new URLSearchParams(location.search).get(key);
  const [activeTab, setActiveTab] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [filters, setFilters] = useState({
    search: "",
    // year_experience: "",
          nationality: "",

    category: [],
    // subCategory: [],
    age: "",
     availability: { from: null, to: null },
  });

  useEffect(() => {
    if (hasFetchedProfile.current) return;
    hasFetchedProfile.current = true;
    fetchTalents(1, filters);
  }, []);
const { t, i18n } = useTranslation();
  useEffect(() => {
    const currentTab = getQueryParam("subTab");
    if (currentTab && currentTab !== activeTab) {
      setActiveTab(currentTab);
    }
  }, [location.search]);
  const handleClear = () => {
    setFilters({
      search: "",
      // year_experience: "",
      category: [],
      nationality: "",
      // subCategory: [],
      age: "",
     availability: { from: null, to: null }
    });
    setFormData({ category: [] });
    fetchTalents(1, {
      search: "",
      // year_experience: "",
      category: [],
      nationality:"",
      // subCategory: [],
      age: "",
      availability: { from: null, to: null },
    });
  };
  useEffect(() => {
    (async () => {
      try {
        const res = await ApiService.request({
          method: "GET",
          url: "/getSkills",
        });
        const categoriesArray = res.data.data.skills;
        setCategoryOptions(
          categoriesArray.map((cat) => ({
            value: cat._id,
            label:
              i18n.language === "ar" ? cat.title_ar || cat.title : cat.title,
          }))
        );
      } catch (err) {
        toast.error("Failed to load categories");
      }
    })();
  }, [i18n.language]);

  const buildQuery = (page, filters) => {
    const params = new URLSearchParams();
    params.append("page", page);

    if (filters.search) params.append("search", filters.search);
    // if (filters.year_experience) params.append("year_experience", filters.year_experience);
    if (filters.nationality) params.append("nationality", filters.nationality);
    if (filters.age) params.append("age", filters.age);
   if (filters.availability?.from && filters.availability?.to) {
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`; // YYYY-MM-DD
    };

    const fromDate = formatDate(filters.availability.from);
    const toDate = formatDate(filters.availability.to);

    params.append("availability[0]", fromDate); // e.g. 2025-02-12
    params.append("availability[1]", toDate);   // e.g. 2025-02-20
  }

 if (filters.category.length > 0) {
    params.append("skills", filters.category.join(","));
  }
    // if (filters.subCategory?.length > 0) {
    //   filters.subCategory.forEach((id) => params.append("sub_category_id[]", id));
    // }

    return params.toString();
  };
  const handleDownload = (url, filename) => {
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename || "resume.png");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
// useEffect(() => {
//   if (!filters.category) {
//     setSubCategoryOptions([]);
//     return;
//   }

//   const fetchSubCategories = async () => {
//     try {
//       const res = await ApiService.request({
//         method: "GET",
//         url: `getSubSkills?skill_id=${filters.category}`,
//       });
//       const subs = res.data.data.skills || [];
//       setSubCategoryOptions(
//         subs.map((s) => ({ value: s._id, label: s.title }))
//       );
//     } catch (e) {
//       console.error("Failed to load sub-categories:", e);
//       toast.error("Failed to load sub-categories");
//     }
//   };

//   fetchSubCategories();
// }, [filters.category]);

  

  const fetchTalents = async (page, filters) => {
    setIsLoading(true)
    
    try {
      const query = buildQuery(page, filters);
      const response = await ApiService.request({
        method: "GET",
        url: `/company/getTalents?${query}`,
      });
      const data = response.data;
      if (data.status && data.data.talents.length > 0) {
        setTalents(data.data.talents);
        setPagination(data.data.pagination);
      } else {
        setTalents([]);
        setPagination({ current_page: 1, total_pages: 1 });
      }
    } catch (error) {
      setTalents([]);
      setPagination({ current_page: 1, total_pages: 1 });
    } finally{
      setIsLoading(false)
    }
  };

  const handleSearch = () => {
    fetchTalents(1, filters);
  };

  // Handle Filter button click
  const handleFilter = () => {
    fetchTalents(1, filters);
  };
  const handleInputChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  };
  const handleSelectChange = (name, selectedOptions) => {
    setFormData((prev) =>
      name === "category"
        ? { ...prev, category: selectedOptions.value, subCategory: [] }
        : { ...prev, subCategory: selectedOptions.map((o) => o.value) }
    );
  };

  // const toggleTalent = (id, talent) => {
  //   setSelectedTalentIds((prev) =>
  //     prev.includes(id) ? prev.filter((tid) => tid !== id) : [...prev, id]
  //   );
  //   setSelectedTalentData((prev) =>
  //     prev.includes(id) ? prev.filter((tid) => tid !== id) : [...prev, talent]
  //   );
  // };
  const toggleTalent = (id, talent) => {
    setSelectedTalentIds((prev) =>
      prev.includes(id) ? prev.filter((tid) => tid !== id) : [...prev, id]
    );
  
    setSelectedTalentData((prev) => {
      const isSelected = selectedTalentIds.includes(id);
  
      if (isSelected) {
        // Remove the talent by ID
        return prev.filter((t) => t._id !== id);
      } else {
        // Add the selected talent
        return [...prev, talent];
      }
    });
  };
  

  console.log(" -selectedTalentIds--- ", selectedTalentIds, selectedTalentData);

  const yearOptions = [
    { value: "", label: "Year of Exp" },
    { value: "1-3", label: "1-3 years" },
    { value: "4-6", label: "4-6 years" },
    { value: "7+", label: "7+ years" },
  ];

  const ageOptions = [
    { value: "", label: "Age" },
    { value: "18-25", label: "18-25" },
    { value: "26-35", label: "26-35" },
    { value: "36+", label: "36+" },
  ];

  const availabilityOptions = [
    { value: "", label: "Availability" },
    { value: "available", label: "Available" },
    { value: "not_available", label: "Not Available" },
  ];


  const handlePageChange = (newPage) => {
    if (
      newPage >= 1 &&
      newPage <= pagination.total_pages &&
      newPage !== pagination.current_page
    ) {
      fetchTalents(newPage);
    }
  };

  const { current_page, total_pages } = pagination;

  // Generate page numbers (for large datasets show 1,2,3,...,last)
  const getPages = () => {
    const pages = [];

    if (total_pages <= 5) {
      for (let i = 1; i <= total_pages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      if (current_page > 3) {
        pages.push("...");
      }
      for (
        let i = Math.max(2, current_page - 1);
        i <= Math.min(total_pages - 1, current_page + 1);
        i++
      ) {
        pages.push(i);
      }
      if (current_page < total_pages - 2) {
        pages.push("...");
      }
      pages.push(total_pages);
    }

    return pages;
  };

  const pages = getPages();
  const [expandedTalents, setExpandedTalents] = useState({});

  // Toggle read more/less for a specific talent
  // const toggleReadMore = (talentId) => {
  //   setExpandedTalents(prev => ({
  //     ...prev,
  //     [talentId]: !prev[talentId]
  //   }));
  // };
  const [expandedTalentIds, setExpandedTalentIds] = useState([]);
  const toggleReadMore = (id) => {
    setExpandedTalentIds((prev) =>
      prev.includes(id)
        ? prev.filter((item) => item !== id)
        : [...prev, id]
    );
  };

// Custom MultiValue container to limit display
// const MultiValue = (props) => {
//   const maxToShow = 2;
//   const selected = props.getValue(); // This is correct here
//   if (props.index >= maxToShow) return null;
//   return <components.MultiValue {...props} />;
// };

// // Custom MultiValueContainer to handle the "+X more"
// const MultiValueContainer = (props) => {
//   const maxToShow = 2;
//   const selected = props.selectProps.value || []; // get selected options from selectProps

//   // Only show "+X more" at the last visible slot
//   if (selected.length > maxToShow && props.index === maxToShow - 1) {
//     return (
//       <div style={{ marginLeft: "4px", color: "#6c757d", fontSize: "14px" }}>
//         +{selected.length - maxToShow} more
//       </div>
//     );
//   }

//   return <components.MultiValueContainer {...props} />;
// };


const handleDownloadTalent = async (talentId) => {
  try {
    const response = await ApiService.request({
      method: "GET",
      url: `/company/getTalentDetails?talent_id=${talentId}`,
    });

    const data = response.data;
    if (!data.status) {
      toast.error("Failed to fetch talent details");
      return;
    }

    const talent = data.data.talent;
    const projects = data.data.jobs;

    // Calculate Age
    const dob = new Date(talent.dob);
    const age = talent.age;
    const flagUrl = talent.country_flag || "https://upload.wikimedia.org/wikipedia/commons/c/cb/Flag_of_the_United_Arab_Emirates.svg";
    const countryNationalityText = [
      talent.country,
      talent.nationality
    ].filter(Boolean).join(", ");

    // Better text for years of experience
    const yearsExperience = talent.year_experience || 0;
    let experienceText = "";
    if (yearsExperience === 0) {
      experienceText = "Fresher";
    } else if (yearsExperience === 1) {
      experienceText = "1 Year";
    } else {
      experienceText = `${yearsExperience}+ Years`;
    }

    // Create PDF container with explicit LTR direction
    const pdfContainer = document.createElement("div");
    pdfContainer.style.width = "900px";
    pdfContainer.style.padding = "40px 60px";
    pdfContainer.style.background = "#fff";
    pdfContainer.style.fontFamily = "'Inter', sans-serif";
    pdfContainer.style.color = "#000";
    pdfContainer.style.lineHeight = "1.6";
    pdfContainer.style.direction = "ltr"; // Force LTR
    pdfContainer.style.textAlign = "left"; // Force left alignment

    pdfContainer.innerHTML = `
      <!-- Header Section -->
      <div style="display: flex; justify-content: space-between; align-items: flex-start;">
        <div style="display: flex; gap: 15px; align-items: center;">
          <img src="${talent.picture || ""}" 
               style="width: 110px; height: 110px; border-radius: 50%; object-fit: cover;" />
          <div>
            <h2 style="margin: 0; font-weight: 700; font-size: 20px;">
              ${talent.first_name} ${talent.last_name}
            </h2>
            <p style="margin: 4px 0; color: #4e4e4e; font-weight: 500; display: flex; align-items: center; gap: 5px;">
              <img src="${flagUrl}"
                   style="width: 22px; height: 15px; vertical-align: middle; border-radius: 2px;" />
              ${countryNationalityText}
            </p>
          </div>
        </div>

        <!-- Company Logo -->
        <img src="${logo}" 
             style="width: 130px; height: auto; object-fit: contain; margin-top: 10px;" />
      </div>

      <!-- Info Section -->
      <div style="margin-top: 25px; display: flex; gap: 60px; font-size: 14px; color: #333;">
        <div><b>Age</b><br>${age} Years</div>
        <div><b>Experience</b><br>${experienceText}</div>
      </div>

      <!-- Biography -->
      <div style="margin-top: 25px;">
        <h3 style="font-size: 17px; font-weight: 700; margin-bottom: 10px;">Biography</h3>
        <p style="font-size: 13px; color: #4e4e4e; text-align: justify;">
          ${talent.about || "No biography available."}
        </p>
      </div>

      <!-- Bullet Points -->
      <ul style="color: #4e4e4e; font-size: 13px; margin-top: 15px; padding-left: 20px;">
        <li>Totam rem aperiam, eaque ipsa quae ab illo inventore perspiciatis unde omnis iste natus error sit voluptatem.</li>
        <li>But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give.</li>
        <li>Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime.</li>
        <li>Mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio.</li>
        <li>Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime.</li>
      </ul>

      <!-- Past Projects -->
      <div style="margin-top: 30px;">
        <h3 style="font-size: 17px; font-weight: 700; margin-bottom: 10px;">Past Projects</h3>
        ${
          projects && projects.length > 0
            ? projects
                .map(
                  (proj) => `
                    <p style="margin: 2px 0; font-size: 13px;">
                      <a href="#" style="color: #0049d9; text-decoration: underline;">
                        ${proj.title || "Untitled Project"} - ${proj.company || ""}
                      </a>
                    </p>
                  `
                )
                .join("")
            : `<p style="font-size: 13px; color: #777;">No past projects listed</p>`
        }
      </div>
    `;

    // Append temporarily for rendering
    document.body.appendChild(pdfContainer);

    // Convert to Canvas
    const canvas = await html2canvas(pdfContainer, { scale: 2, useCORS: true });
    const imgData = canvas.toDataURL("image/png");

    // Generate PDF
    const pdf = new jsPDF("p", "mm", "a4");
    const pdfWidth = 210;
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save(`${talent.first_name}_${talent.last_name}_profile.pdf`);

    // Cleanup
    document.body.removeChild(pdfContainer);
  } catch (err) {
    console.error(err);
    toast.error("Failed to generate talent PDF");
  }
};
const categorySelectStyles = {
  control: (base) => ({
    ...base,
    minHeight: 40,
    height: 40,
    borderRadius: 8,
    border: "none",
    boxShadow: "none",
    backgroundColor: "white",
    fontSize: 14,
    overflow: "hidden",
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 10px",
    display: "flex",
    flexWrap: "nowrap", // ✅ keeps tags on one line
    overflow: "hidden", // ✅ hides anything that doesn't fit
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    alignItems: "center",
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: "#cd496d",
    color: "white",
    borderRadius: 4,
    marginRight: 4,
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: "white",
    fontSize: 13,
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: "white",
    ':hover': {
      backgroundColor: "#a03c58",
      color: "white",
    },
  }),
  placeholder: (base) => ({
    ...base,
    color: "#6c757d",
  }),
  menu: (base) => ({
    ...base,
    borderRadius: 8,
    backgroundColor: "white",
    zIndex: 1050,
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isFocused ? "rgba(65,19,24,0.08)" : "white",
    color: "#212529",
    cursor: "pointer",
  }),
};

const SingleValueForMulti = (props) => {
  const selected = props.getValue();
  if (!selected || selected.length === 0) return null;

  // Show only the first selected label
  return (
    <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
      {selected[0].label}
    </div>
  );
};
      const isRTL = i18n.language === 'ar';
  return (
    <div className="inter-font py-4 inter-font">
      {activeTab === "hire" ? (
        <HireTheTalent selectedTalentData={selectedTalentData} />
      ) : (
        <Container fluid className="inter-font md:px-4">
{/* Search Row */}
<Row className="mb-3 w-100" style={{ marginLeft: 0, marginRight: 0 }}>
  <Col
    xs={12}
    className="d-flex gap-2 p-0"
    style={{ display: "flex", alignItems: "end" }} 
  >
    {/* Search Input */}
    <div
      className="position-relative flex-grow-1"
      style={{ height: "44px", display: "flex", alignItems: "end" }}
    >
      {isRTL ?  <CiSearch
                  className="inter-font position-absolute"
                  style={{
                    right: "12px",
                    top: "50%",
                    transform: "translateY(-50%) scaleX(-1)",
                    pointerEvents: "none",
                  }}
                  size={20}
                /> : null }
      <input
        type="text"
        placeholder={t("c_ff_text65")}
        value={filters.search}
        onChange={(e) => handleInputChange("search", e.target.value)}
        className={`inter-font w-100 p-2 rounded-3 ${isRTL ? 'pe-5' : 'ps-5'} inter-font`}
        style={{
          height: "100%",
          border: "none",
          outline: "none",
          paddingRight: "1rem",
          boxSizing: "border-box",
        }}
      />
      
     {isRTL ? null : <CiSearch
        className="position-absolute"
        style={{
          left: "16px",
          top: "50%",
          transform: "translateY(-50%)",
          color: "#666",
        }}
        size={20}
      />}
    </div>

    {/* Search Button */}
    <Button
      className="inter-font btn btn-base border-0 dashboard-btn"
      style={{
        height: "44px",
        padding: "0 18px",
        whiteSpace: "nowrap",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        boxSizing: "border-box",
        lineHeight: "1",
      }}
      onClick={handleSearch}
    >
      {t("c_ff_text66")}
    </Button>
  </Col>
</Row>


<Row className="align-items-center mb-3">
  <Col xs={12} className="d-flex flex-wrap align-items-center gap-2">

    {/* Category MultiSelect */}
      {/* Category MultiSelect */}
<div style={{ flex: 1, minWidth: "150px" }}>
  <Select
    isMulti
     options={[...categoryOptions].sort((a, b) =>
    a.label.localeCompare(b.label)
  )}
    value={categoryOptions.filter(opt => filters.category.includes(opt.value))}
    onChange={(selected) =>
      setFilters(prev => ({
        ...prev,
        category: selected.map(s => s.value),
      }))
    }
    placeholder={t("new_text_3")}
    styles={{
      control: (base) => ({
        ...base,
        height: 40,
        minHeight: 40,
        fontSize: 14,
        borderRadius: 8,
        border: "none",
        boxShadow: "none",
        backgroundColor: "white",
      }),
      valueContainer: (base) => ({
        ...base,
        display: "flex",
        flexWrap: "nowrap",
        overflow: "hidden",
        padding: "0 10px",
      }),
      multiValue: (base) => ({
        ...base,

        borderRadius: 4,
        flexShrink: 0,
        marginRight: 4,
      }),
      multiValueLabel: (base) => ({
        ...base,
        fontSize: 13,
      }),
      multiValueRemove: (base) => ({
        ...base,
        color: "white",
        ':hover': {
          backgroundColor: "#a03c58",
          color: "white",
        },
      }),
      placeholder: (base) => ({
        ...base,
        color: "#6c757d",
      }),
      menu: (base) => ({
        ...base,
        borderRadius: 8,
        backgroundColor: "white",
        fontSize: 14,
        zIndex: 1050,
      }),
      option: (base, state) => ({
        ...base,
        backgroundColor: state.isFocused ? "rgba(65,19,24,0.08)" : "white",
        color: "#212529",
        padding: "8px 10px",
        cursor: "pointer",
      }),
    }}
  />
</div>



 {/* Nationality Select */}
<div style={{ flex: 1, minWidth: "120px" }}>
  <Select
    options={[
       { value: "Arab", label: t("nationality_arab") },
  { value: "Non Arab", label: t("nationality_non_arab") },
  { value: "Emirati", label: t("nationality_emirati") },
    ]}
    value={
      filters.nationality
        ? { value: filters.nationality, label: filters.nationality }
        : null 
    }
    onChange={(opt) =>
      setFilters((prev) => ({ ...prev, nationality: opt?.value || "" }))
    }
    placeholder={t("new_text_6")}
    isClearable
    styles={{
      control: (base) => ({
        ...base,
        height: 40,
        minHeight: 40,
        fontSize: 14,
        borderRadius: 8,
        border: "none",
        boxShadow: "none",
        backgroundColor: "white",
      }),
      valueContainer: (base) => ({ ...base, padding: "0 10px" }),
      placeholder: (base) => ({ ...base, color: "#6c757d" }),
      menu: (base) => ({ ...base, borderRadius: 8, fontSize: 14 }),
      option: (base, state) => ({
        ...base,
        backgroundColor: state.isFocused ? "rgba(65,19,24,0.08)" : "white",
        color: "#212529",
        padding: "8px 10px",
        cursor: "pointer",
      }),
    }}
  />
</div>

{/* Age Select */}
<div style={{ flex: 1, minWidth: "100px" }}>
  <Select
    options={[
      { value: "0-5", label: "0-5" },
      { value: "6-10", label: "11-15" },
      { value: "16-26", label: "16-26" },
      { value: "27-40", label: "27-40" },
      { value: "41+", label: "41+" },
    ]}
    value={filters.age ? { value: filters.age, label: filters.age } : null} // placeholder when nothing selected
    onChange={(opt) => handleInputChange("age", opt?.value || "")}
    isClearable
    placeholder={t("new_text_7")}
    styles={{
      control: (base) => ({
        ...base,
        height: 40,
        minHeight: 40,
        fontSize: 14,
        borderRadius: 8,
        border: "none",
        boxShadow: "none",
        backgroundColor: "white",
           direction: "ltr", 
        textAlign: "left",
      }),
      valueContainer: (base) => ({ ...base, padding: "0 10px", direction: "ltr", }),
      placeholder: (base) => ({ ...base, color: "#6c757d",  }),
      menu: (base) => ({ ...base, borderRadius: 8, fontSize: 14,  direction: "ltr", // Force LTR direction
        textAlign: "left", }),
      option: (base, state) => ({
        ...base,
        backgroundColor: state.isFocused ? "rgba(65,19,24,0.08)" : "white",
        color: "#212529",
        padding: "8px 10px",
        cursor: "pointer",
         direction: "ltr", // Force LTR direction
        textAlign: "left",
      }),
    }}
  />
</div>


    {/* Date Range */}
    <div style={{ flex: "1 1 250px", minWidth: "250px" }}>
      <DateRangePicker
        initialSettings={{ minDate: moment().startOf("day") }}
        onApply={(event, picker) => {
          setFilters({
            ...filters,
            availability: {
              from: picker.startDate.toDate(),
              to: picker.endDate.toDate(),
            },
          });
        }}
        autoUpdateInput={false}
        opens="right"
      >
        <input
          type="text"
          className="form-control"
          placeholder={t("new_text_42")}
          style={{
            height: 40,
            fontSize: 14,
            padding: "0 10px",
            borderRadius: 8,
            border: "none",
            backgroundColor: "white",
            boxShadow: "none",
            color: "#212529",
          }}
          value={
            filters.availability.from && filters.availability.to
              ? `${filters.availability.from.toLocaleDateString()} - ${filters.availability.to.toLocaleDateString()}`
              : ""
          }
          readOnly
        />
      </DateRangePicker>
    </div>

    {/* Filter Button */}
    <Button
      className="inter-font btn px-3 d-flex align-items-center justify-content-center"
      style={{
        background: "#cd496d",
        color: "white",
        height: "44px",
        gap: "6px",
        whiteSpace: "nowrap",
      }}
      onClick={handleFilter}
    >
     {isRTL ? null : <CiSearch size={18} />} 
        {isRTL ?  <CiSearch
                  style={{
                    transform: " scaleX(-1)",
                  }}
                  size={18}
                /> : null } 
     {t("c_ff_text68")}
    </Button>
  </Col>

 <style global jsx>{`
    /* Container of MultiSelect */
    .custom-multi-select {
      background-color: white !important;
      border-radius: 8px !important;
      border: none !important;
      min-height: 40px !important;
      font-size: 14px !important;
    }

    /* Selected tags */
    .custom-multi-select__selected {
      background-color: #cd496d !important;
      color: white !important;
      border-radius: 4px !important;
      padding: 2px 6px !important;
      margin-right: 4px !important;
    }

    /* Dropdown menu */
    .custom-multi-select__menu {
      background-color: white !important;
      border: none !important;
      box-shadow: none !important;
      border-radius: 8px !important;
      font-size: 14px !important;
      z-index: 1050;
    }

    /* Dropdown options */
    .custom-multi-select__option {
      padding: 8px 10px !important;
      color: #212529 !important;
      cursor: pointer !important;
    }

    .custom-multi-select__option:hover {
      background-color: rgba(65,19,24,0.08) !important;
    }

    /* Selected option in dropdown */
    .custom-multi-select__option--selected {
      background-color: #cd496d !important;
      color: white !important;
    }

    /* Search input inside dropdown */
    .custom-multi-select__input {
      padding: 0 10px !important;
      background-color: white !important;
    }

    /* Placeholder */
    .custom-multi-select__placeholder {
      color: #6c757d !important;
    }
  `}</style>
</Row>



<Row
  className="inter-font mt-3 gx-0" 
  style={{
    marginLeft: 0,
    marginRight: 0,
    position: "sticky",
    top: 0,
    zIndex: 1000,
  }}
>
  <Col
    className="inter-font d-flex justify-content-end align-items-center gap-2 mb-4 px-0 "
  >
    <Button
      className="inter-font bg-light border clear-btn"
      style={{
        color: "rgba(82, 42, 48, 1)",
        width: "88px",
        height: "44px",
      }}
      onClick={handleClear}
    >
      {t("c_ff_text67")} 
    </Button>

    <Button
      className="inter-font btn border-0 d-flex align-items-center justify-content-center gap-1"
      style={{
        background: "rgba(82, 42, 48, 1)",
        color: "white",
        width: "88px",
        height: "44px",
        opacity: profileData?.approval_status !== "Approved" ? 0.6 : 1,
        cursor: profileData?.approval_status !== "Approved" ? "not-allowed" : "pointer",
      }}
      disabled={selectedTalentIds.length === 0 || profileData?.approval_status !== "Approved"}
      title={profileData?.approval_status !== "Approved" ? "Your account is pending approval" : ""}
      onClick={() =>
        navigate("/company/hire-talent", {
          state: { selectedTalentData },
        })
      }
    >
      {t("c_ff_text69")} 
      <MdArrowOutward fontSize={20} />
    </Button>
  </Col>
</Row>


          <Row className="inter-font gx-3 inter-font">
          {isLoading ? (
    <div className="d-flex justify-content-center w-100 py-5">
      <p className="mb-0 text-muted">Loading...</p>
    </div>
  ) : talents.length === 0 ? (
<div className="text-center my-4">
          <div style={{ maxWidth: 200, margin: "0 auto" }}>
            <Lottie animationData={NoResultAnimation} loop={true} />
          </div>
        </div>
  ) : (
           

            talents?.map((talent) => {
              return (
             

<Col xs={12} key={talent._id} className="inter-font mb-3">
<div className="p-3 bg-white rounded-4 d-flex flex-column shadow-sm w-100">
  {/* Top Row: Image + Name + About + Checkbox */}
  <div className="d-flex flex-column flex-md-row gap-3 w-100">
    {/* Image */}
    <div>
      <Image
        src={talent?.picture}
        alt="logo"
        style={{
          width: "88px",
          height: "88px",
          objectFit: "cover",
          borderRadius: "50%",
          border: "2px solid #ddd",
        }}
      />
    </div>

    {/* Info + About + Checkbox */}
    <div className="flex-grow-1 d-flex flex-column gap-3" >
      <div className="d-flex flex-column flex-md-row  align-items-start gap-5" >
        {/* Name + Location */}
        <div>
  <h5 className="mb-1 fw-bold d-flex align-items-center gap-1">
  <span>{talent.first_name}</span>
  <span>{talent.last_name}</span>
  </h5>
{(talent.nationality || talent.country) && (
  <div
    className={`text-muted d-flex align-items-center ${isRTL ? 'flex-row-reverse' : ''}`}
    style={{
      flexWrap: "nowrap",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    }}
  >
    {/* Location Icon */}
    <img
      src={LocationDot}
      alt="Location Icon"
      style={{
        width: "15px",
        height: "19px",
        flexShrink: 0,
        marginRight: "6px",
      }}
    />

    {/* Nationality + Country (comma handled dynamically) */}
    <span
      className="d-flex align-items-center"
      style={{ flexShrink: 1, gap: "4px" }}
    >
      {talent.nationality && <span>{talent.nationality}</span>}
      {talent.nationality && talent.country && <span>,</span>}
      {talent.country && <span>{talent.country}</span>}
    </span>

    {/* Country Flag */}
    {talent.country_flag && (
      <Image
        src={talent.country_flag}
        alt={talent.country || "Flag"}
        style={{
          width: "22px",
          height: "15px",
          marginLeft: "6px",
          borderRadius: "2px",
          objectFit: "cover",
          flexShrink: 0,
        }}
      />
    )}
  </div>
)}




</div>


        {/* About + Checkbox */}
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-start gap-3" style={{width:"100%"}}>
          <div className="w-100 w-md-75" >
            {talent.about && (
              <p style={{ fontSize: "14px", margin: 0, lineHeight: "1.4" }}>
                {expandedTalentIds.includes(talent._id)
                  ? talent.about
                  : talent.about.slice(0, 90) + (talent.about.length > 90 ? "..." : "")}
                {talent.about.length > 90 && (
                  <span
                    className="text-danger fw-semibold"
                    style={{ cursor: "pointer", marginLeft: 5 }}
                    onClick={() => toggleReadMore(talent._id)}
                  >
                    {expandedTalentIds.includes(talent._id) ? " Read Less" : " Read More"}
                  </span>
                )}
              </p>
            )}
          </div>

          {/* Checkbox */}
          <div className="d-flex align-items-start">
          <input
                                type="checkbox"
                                disabled={profileData?.approval_status !== "Approved"}
                                title={profileData?.approval_status !== "Approved" ? "Your account is pending approval" : ""}
                                checked={selectedTalentIds.includes(talent._id)}
                                onChange={() => toggleTalent(talent._id, talent)}
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  borderRadius: "50%",
                                  border: "2px solid #ccc",
                                  appearance: "none",
                                  WebkitAppearance: "none",
                                  MozAppearance: "none",
                                  outline: "none",
                                  cursor: "pointer",
                                  backgroundColor: selectedTalentIds.includes(
                                    talent._id
                                  )
                                    ? "#6d5e2b"
                                    : "#fff",
                                  backgroundImage: selectedTalentIds.includes(
                                    talent._id
                                  )
                                    ? `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 24 24' fill='white'><path d='M20.285 6.709l-11.401 11.401-5.285-5.287 1.414-1.414 3.871 3.873 9.987-9.989z'/></svg>")`
                                    : "none",
                                  backgroundRepeat: "no-repeat",
                                  backgroundPosition: "center",
                                  backgroundSize: "12px 12px",
                                  transition: "0.2s",
                                }} />
          </div>
        </div>
      </div>

      {/* Skills + Buttons */}
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-start gap-3">
        {/* Skills */}
         <div className="d-flex flex-wrap gap-2">
    {talent.skill_id ? 

          <span
            className="bg-light px-2 py-1 rounded small text-muted border"
          >
            {i18n.language === "ar"
              ? talent.skill_id.title_ar || talent.skill_id.title
              : talent.skill_id.title}
          </span>
        
 
     : (
     null
    )}

    {talent.year_experience && (
      <span className="bg-light px-2 py-1 rounded small text-muted border">
        {talent.year_experience} Y Ex
      </span>
    )}
  </div>

        {/* Buttons */}
        <div className="d-flex gap-2 mt-2 mt-md-0 justify-content-md-end flex-wrap">
          <Button
            size="sm"
            style={{ background: "#522a30", color: "#fff", borderRadius: "5px" }}
             onClick={() => handleDownloadTalent(talent._id)}
            // disabled={!talent.resume}
          >
            <LiaDownloadSolid /> {t("new_text_41")}
          </Button>
          <Link
  to={{
    pathname: `/company/talent-profile`,
  }}
  state={{ talentId: talent._id }}
>  <Button
    size="sm"
    style={{ background: "#522a30", color: "#fff", borderRadius: "5px" }}
  >
    {t("c_s_tab10")}
  </Button>
</Link>
        </div>
      </div>
    </div>
  </div>
</div>
</Col>

              )
            })


          )}
          </Row>


          <Row className="inter-font mt-4">
            <Col className="inter-font d-flex justify-content-center align-items-center gap-5 flex-wrap">

             
                      {/* Pagination */}
        {pagination?.total_pages > 1 && (
                <Paginator
                    page={pagination.current_page}
                    rows={pagination.per_page}
                    totalRecords={pagination.total_records}
                    onPageChange={handlePageChange}
                />
            )}
            </Col>
          </Row>
        </Container>
      )}
    </div>
  );
};

export default Talents;
